const TikTokIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M16.4989 7.9161V5.02464C12.5558 4.86538 12.4312 1.43048 12.4267 1.10873V1.08398H9.38175V12.3442C9.38175 13.6226 8.30055 14.6578 6.96672 14.6578C5.63289 14.6578 4.55281 13.6215 4.55281 12.3431C4.55281 11.0647 5.63401 10.0295 6.96784 10.0295C7.20586 10.0295 7.44276 10.064 7.67181 10.1296V7.14777C4.67743 6.77544 1.93567 8.79849 1.54608 11.6684C1.1576 14.5384 3.26838 17.1662 6.26275 17.5396C9.25713 17.913 11.9989 15.8889 12.3885 13.0189C12.4188 12.7951 12.4345 12.5702 12.4345 12.3442C12.4345 12.271 12.4323 12.1979 12.4289 12.1258V6.58066C13.8323 7.81064 16.5 7.9161 16.5 7.9161H16.4989Z' />
      </svg>
    </span>
  );
};

export default TikTokIcon;
